/**
 * Cookie Consent Banner
 * GDPR-compliant consent mechanism for Google Analytics
 *
 * Features:
 * - Shows on first visit only
 * - Stores preference in localStorage
 * - Updates Google Consent Mode on accept
 * - Links to Privacy Policy
 */

import { useState, useEffect } from 'react';

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');

    // Update Google Consent Mode to allow analytics
    if (typeof window.gtag !== 'undefined') {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
    }

    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 shadow-lg z-50 animate-slide-up">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-sm leading-relaxed">
            We use cookies and analytics to improve your experience.
            By clicking "Accept", you consent to our use of cookies and Google Analytics.{' '}
            <a
              href="/privacy"
              className="underline hover:text-indigo-300 transition-colors"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = '/privacy';
              }}
            >
              Privacy Policy
            </a>
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm border border-gray-400 rounded hover:bg-gray-800 transition-colors"
            aria-label="Decline cookies"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm bg-indigo-600 rounded hover:bg-indigo-700 transition-colors"
            aria-label="Accept cookies"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
